import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsecasepageService } from '../usecasepage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-usecases-payment-solutions-feature',
  templateUrl: './usecases-marketplace-paymentsolutions.component.html',
  styleUrls: ['./usecases-marketplace-paymentsolutions.component.scss'],
  imports: [CommonModule, UrlParamsPipe, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class UsecasesCasePaymentSolutionsComponent implements OnInit, OnDestroy {
    @Input() marketPlacePaymentSolutionData: any;
    caseOtherFeatureData: any;
    ngOnInit(): void {
        if (this.marketPlacePaymentSolutionData) {
            this.caseOtherFeatureData = this.marketPlacePaymentSolutionData?.fields;
        }
    }
    ngOnChanges(): void {
        if (this.marketPlacePaymentSolutionData) {
            this.caseOtherFeatureData = this.marketPlacePaymentSolutionData?.fields;
        }
    }
    ngOnDestroy(): void {
        
    }
}